import { environmentConfig } from "@src/appV2/environment/config";
import { DeploymentEnvironmentName } from "@src/appV2/environment/types";

export type SsoMode = "off" | "sso_only" | "sso_and_magic_link";

const SSO_EMPLOYEE_EMAIL_REGEX = /^[^+]+@clipboardhealth\.com$/i;
const VENDOR_BYPASS_SUFFIX = "_3p@clipboardhealth.com";

/**
 * Determines the SSO mode for the given email.
 *
 * - "sso_only": SSO is the only login option (production employees).
 * - "sso_and_magic_link": SSO button shown alongside magic link (non-production employees).
 * - "off": no SSO (non-employees, + aliases, _3p vendor accounts).
 */
export function getSsoMode(email: string): SsoMode {
  const trimmedEmail = email.trim();
  const isCbhEmployeeEmail =
    SSO_EMPLOYEE_EMAIL_REGEX.test(trimmedEmail) &&
    !trimmedEmail.toLowerCase().endsWith(VENDOR_BYPASS_SUFFIX);

  if (!isCbhEmployeeEmail) {
    return "off";
  }

  const isProduction =
    environmentConfig.REACT_APP_ENVIRONMENT_NAME === DeploymentEnvironmentName.PRODUCTION;

  return isProduction ? "sso_only" : "sso_and_magic_link";
}
